import './Checkbox.scss';

function Checkbox({ checked, onChange, label, disabled = false, className = '', required = false, ...rest }) {
  return (
    <label className={`checkbox ${disabled ? 'checkbox--disabled' : ''} ${className}`}>
      <input
        type="checkbox"
        className="checkbox__input"
        checked={checked}
        onChange={(e) => !disabled && onChange?.(e.target.checked)}
        disabled={disabled}
        required={required}
        {...rest}
      />
      <span className="checkbox__box">
        <svg className="checkbox__check" viewBox="0 0 12 12">
          <path d="M2 6l3 3 5-5" />
        </svg>
      </span>
      {label && <span className="checkbox__label">{label}</span>}
    </label>
  );
}

export default Checkbox;
